import { ClueCategory } from '@uniquegood/realworld-admin-interface';

export const clueCategoryToLabel: Record<ClueCategory, string> = {
  [ClueCategory.MultiPlayerBest]: '다인용 BEST',
  [ClueCategory.SinglePlayerBest]: '1인용 BEST',
  [ClueCategory.New]: 'NEW'
};
